export const APP_NAME = process.env.REACT_APP_APP_NAME || "RizzAura";

export const LANGUAGES = [
  { id: "auto", name: "Auto-match", desc: "Mirror their language" },
  { id: "english", name: "English", desc: "Casual texting English" },
  { id: "hinglish", name: "Hinglish", desc: "Hindi + English, Latin script" },
  { id: "hindi", name: "Hindi", desc: "देवनागरी में" },
];

export const INTENSITIES = [
  { id: "friendly", name: "Friendly", desc: "Warm, casual and approachable.", grad: "from-teal-500 to-emerald-500" },
  { id: "subtle", name: "Subtle", desc: "Light hints of interest.", grad: "from-sky-500 to-indigo-500" },
  { id: "playful", name: "Playful", desc: "Teasing, witty and fun.", grad: "from-violet-500 to-purple-600" },
  { id: "romantic", name: "Romantic", desc: "Charming and affectionate.", grad: "from-fuchsia-500 to-pink-500" },
  { id: "bold", name: "Bold", desc: "Confident and direct, never disrespectful.", grad: "from-pink-500 to-rose-600" },
];

export const PERSONALITIES = [
  { id: "smooth", name: "Smooth & Confident", icon: "Sparkles" },
  { id: "witty", name: "Funny & Witty", icon: "Laugh" },
  { id: "sweet", name: "Cute & Sweet", icon: "Heart" },
  { id: "romantic", name: "Charming & Romantic", icon: "Flower2" },
  { id: "teasing", name: "Teasing & Playful", icon: "Zap" },
  { id: "calm", name: "Calm & Natural", icon: "Leaf" },
  { id: "mysterious", name: "Mysterious but Respectful", icon: "Moon" },
];

export const RIZZ_STYLES = [
  { id: "smooth", name: "Smooth Rizz", desc: "Effortless confidence and charm." },
  { id: "funny", name: "Funny Rizz", desc: "Witty replies and playful banter." },
  { id: "flirty", name: "Flirty Rizz", desc: "Clear but respectful romantic interest." },
  { id: "savage", name: "Savage Rizz", desc: "Clever comebacks, never cruel." },
  { id: "cute", name: "Cute Rizz", desc: "Sweet, playful and endearing." },
  { id: "bold", name: "Bold Rizz", desc: "Direct and confident, no pressure." },
  { id: "hinglish", name: "Hinglish Rizz", desc: "Natural desi-style flirting." },
  { id: "one_liner", name: "One-Liner Rizz", desc: "Short, memorable replies." },
  { id: "romantic", name: "Romantic Rizz", desc: "Warm, charming, affectionate." },
  { id: "custom", name: "Custom Rizz", desc: "Describe the exact tone you want." },
];

export const RIZZ_CONTROLS = [
  { key: "intensity", label: "Rizz intensity", options: [["subtle", "Subtle"], ["medium", "Medium"], ["bold", "Bold"]] },
  { key: "length", label: "Reply length", options: [["short", "Short"], ["medium", "Medium"], ["detailed", "Detailed"]] },
  { key: "language", label: "Language", options: [["english", "English"], ["hinglish", "Hinglish"], ["hindi", "Hindi"]] },
  { key: "emoji", label: "Emoji level", options: [["none", "None"], ["low", "Low"], ["expressive", "Expressive"]] },
  { key: "personality", label: "Personality", options: [["smooth", "Smooth"], ["funny", "Funny"], ["cute", "Cute"], ["confident", "Confident"], ["romantic", "Romantic"]] },
];

export const DEFAULT_RIZZ = { style: "smooth", custom_tone: "", intensity: "medium", length: "short", language: "english", emoji: "low", personality: "smooth" };

export const VOICES = ["alloy", "ash", "coral", "echo", "fable", "nova", "onyx", "sage", "shimmer"];

export const TONE_TWEAKS = [
  { id: "shorter", label: "Shorter", value: "Make the replies shorter and punchier." },
  { id: "funnier", label: "Funnier", value: "Make the replies funnier." },
  { id: "softer", label: "Less flirty", value: "Tone the flirting down; keep it friendly." },
  { id: "confident", label: "More confident", value: "Make the replies more confident." },
  { id: "noemoji", label: "No emojis", value: "Do not use any emojis." },
  { id: "question", label: "Ask a question", value: "End each reply with a light question to keep the chat going." },
];

export const SAMPLE_CHATS = [
  {
    id: "funny",
    title: "The compliment",
    platform: "Instagram DM",
    messages: [
      { speaker: "me", text: "ok that reel was criminally accurate" },
      { speaker: "them", text: "You always have something funny to say 😂" },
    ],
    examples: [
      { label: "Playful", text: "Maybe you're just giving me good material 😂" },
      { label: "Smooth", text: "Only because you make the conversation interesting 😉" },
      { label: "Funny", text: "I accept compliments in coffee form, by the way 😂" },
    ],
  },
  {
    id: "wyd",
    title: "Late-night WYD",
    platform: "WhatsApp",
    messages: [
      { speaker: "them", text: "wyd" },
      { speaker: "me", text: "pretending to be productive. you?" },
      { speaker: "them", text: "same lol, can't sleep" },
    ],
    examples: [
      { label: "Calm", text: "Same club then. What's keeping you up?" },
      { label: "Teasing", text: "Insomnia buddies, finally a team I'd join 😌" },
      { label: "Sweet", text: "Want me to tell you the most boring story ever? Guaranteed sleep." },
    ],
  },
  {
    id: "hinglish",
    title: "Hinglish banter",
    platform: "Telegram",
    messages: [
      { speaker: "them", text: "Tum hamesha late reply karte ho 🙄" },
    ],
    examples: [
      { label: "Playful", text: "Acha toh tum wait karti ho mere reply ka? Noted 😏" },
      { label: "Sweet", text: "Sorry yaar, ab se tumhare liye fast mode on ⚡" },
      { label: "Witty", text: "Main suspense build kar raha tha, kaam kar gaya na? 😂" },
    ],
  },
  {
    id: "boundary",
    title: "When they say no",
    platform: "Bumble",
    messages: [
      { speaker: "me", text: "would you want to grab coffee this weekend?" },
      { speaker: "them", text: "I think we're better as friends tbh. hope that's ok" },
    ],
    examples: [
      { label: "Respectful", text: "Totally okay, thanks for being honest with me 🙂" },
      { label: "Warm", text: "Appreciate you saying it straight. Friends it is." },
      { label: "Graceful", text: "No worries at all — take care!" },
    ],
  },
];
